export const FormHeader = ({ title, description, theme }) => {
  if (!title && !description) return null;
  
  return (
    <>
      {title && <h2 className={theme.title}>{title}</h2>}
      {description && <p className="text-gray-600 mb-4">{description}</p>}
    </>
  );
};